module.exports = __webpack_public_path__ + "img/banner-1.7f0f7cfd.jpeg";